export const schedulerTypes = {
  SCHEDULED: 'scheduled',
  DEFAULT: 'default'
}
